<script setup>

const emit = defineEmits(['historyAddToCart']);

</script>

<template>
  <div class="modal com_modal2 fade" id="historyAddToCartConfirm2Modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1">カートに同一商品が入っています</h3>
          <p class="com_fs14 com_center1 com_mgb0">個数を合算しますか</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd1" @click="emit('historyAddToCart')">はい</button>
          <button type="button" class="btn com_btn2 wd1" data-bs-dismiss="modal">いいえ</button>
        </div>
      </div>
    </div>
  </div>
</template>